import React from 'react';
import { Clock } from 'lucide-react';

export const Footer = () => {
  return (
    <footer 
      data-testid="footer"
      className="bg-white border-t border-gray-200 pt-16 pb-8 px-8 md:px-12"
    >
      <div className="max-w-6xl mx-auto">
        {/* Three Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-12 md:gap-16 mb-16">
          
          {/* Left Column - Copyright & Disclaimer */}
          <div className="text-center">
            <h4 className="font-editorial text-base font-bold italic text-gray-800 mb-6">
              © Copyright Payne's Education. All Rights Reserved.
            </h4>
            
            <p className="font-sans text-sm text-gray-400 leading-relaxed mb-6">
              Charles Payne's results are not typical and are not a guarantee of your success. Charles is an experienced investor and your results will vary depending on education, work experience, and background. Charles does not personally participate in every investment alert he provides. Due to sensitivity of financial information, we do not know or track the typical results of our students. Charles' strategies may not always be accurate, and his investments may not always be profitable. They could result in a loss of an entire investment. We cannot guarantee that you will make money or that you will be successful if you employ his trading strategies specifically or generally. Consequently, your results may significantly vary from his. We do not give investment advice, tax advice, or other professional advice. Reference to specific securities should not be construed as a recommendation to buy, sell or hold that security. Specific securities are mentioned for informational purposes only.
            </p>

            <p className="font-sans text-sm text-gray-400 mb-4">
              Payne's Education is not endorsed by or affiliated with Fox Business.
            </p>

            <p className="font-sans text-sm text-gray-400 mb-6">
              Making Money with Charles Payne™ is the property of FOX News Network, LLC.
            </p>

            <div className="flex items-center justify-center gap-2">
              <Clock className="w-4 h-4 text-gray-400" />
              <span className="font-sans text-sm text-gray-400">Support replies during normal business hours</span>
            </div>
          </div>

          {/* Middle Column - Policies */}
          <div className="text-center">
            <h4 className="font-sans text-base font-semibold text-gray-500 underline mb-6" data-testid="footer-policies-heading">
              Policies
            </h4>
            <div className="flex flex-col items-center gap-4">
              <a 
                href="https://terms.payneseducation.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-sans text-sm text-gray-400 hover:text-amber-600 transition-colors"
                data-testid="footer-privacy"
              >
                Privacy policy
              </a>
              <a 
                href="https://terms.payneseducation.com/terms/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-sans text-sm text-gray-400 hover:text-amber-600 transition-colors"
                data-testid="footer-terms"
              >
                Terms and conditions
              </a>
            </div>
          </div>

          {/* Right Column - Note */}
          <div className="text-center">
            <h4 className="font-sans text-base font-semibold text-gray-500 underline mb-6" data-testid="footer-note-heading">
              Note
            </h4>
            <p className="font-sans text-sm text-gray-400 leading-relaxed">
              All investments involve risk, and the past performance of a security, industry, sector, market, financial product, investment strategy, or individual's investment does not guarantee future results or returns. Investors are fully responsible for any investment decisions they make. Such decisions should be based solely on an evaluation of their financial circumstances, investment objectives, risk tolerance, and liquidity needs.
            </p>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-gray-100 pt-8">
          <p className="font-sans text-sm text-gray-400 text-center">
            © 2026 Payne's Education, All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};
